var _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 640 480",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 640,
    height: 480,
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9375,0,0,0.9375,138.031,15)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -16,
    width: 512,
    height: 512
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-6.5,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5,489.5L385.3,489.5L137.4,238.1L394.7,238.4L6.6,-9.5L6.6,489.5L6.5,489.5Z",
    style: {
      fill: "rgb(206,0,0)",
      stroke: "rgb(0,0,99)",
      strokeWidth: "13.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.7,355.8L153.7,364.8L174.9,384.6L146.4,382.8L158.1,409L132.6,396.7L133.1,425.3L114.3,404.4L103.6,431L94.4,404.7L74.1,425.3L75.9,397.6L49,409L61.6,384L32.3,384.6L53.8,366.3L26.5,355.8L53.5,346.8L32.2,327L60.6,328.8L49,302.6L74.6,314.9L74.1,286.3L92.9,307.2L103.6,280.6L112.7,306.9L133.1,286.3L131.2,314L158.2,302.6L145.5,327.6L174.9,327L153.4,345.3L180.7,355.8ZM148.3,171.1L137,179.5L142.6,184.1C155.74,174.921 166.311,162.525 173.3,148.1C175.1,169.4 155.6,217.1 104.6,217.6C104.3,217.604 104,217.606 103.699,217.606C65.081,217.606 33.261,185.918 33.1,147.3C43.1,165.5 49.3,174.3 65.1,183.8L69.8,179.4L59.2,170.5L72.9,166.9L65.5,154.5L79.9,155.5L78.1,141.1L90.7,148.5L94.7,135L103.7,145.8L112.2,135.5L116.8,149.5L128.6,141.3L127.1,155.6L141.3,153.9L134.6,167.1L148.3,171.1Z",
    style: {
      fill: "white"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNp);
export default __webpack_public_path__ + "static/media/np.80483565a033885a011b434225977e0e.svg";
export { ForwardRef as ReactComponent };